(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-caffeine-calculator"] && !Shopify.designMode) return;
  try {
    
  const sections = document.querySelectorAll('[data-cc-caffeine-section]');

  sections.forEach((section) => {
    const dataNode = section.querySelector('[data-cc-product-data]');
    const tableNode = section.querySelector('[data-cc-comparison-table]');
    const searchNode = section.querySelector('[data-cc-database-search]');
    const searchCountNode = section.querySelector('[data-cc-search-count]');
    const totalNode = section.querySelector('[data-cc-total]');
    const referenceCopyNode = section.querySelector('[data-cc-reference-copy]');
    const messageNode = section.querySelector('[data-cc-message]');
    const planNode = section.querySelector('[data-cc-plan]');
    const planSummaryNode = section.querySelector('[data-cc-plan-summary]');
    const sleepMessageNode = section.querySelector('[data-cc-sleep-message]');
    const sleepTargetNode = section.querySelector('[data-cc-sleep-target]');
    const sleepReadingNode = section.querySelector('[data-cc-sleep-reading]');
    const sleepGraphicNode = section.querySelector('[data-cc-sleep-graphic]');
    const unitRadios = section.querySelectorAll('[data-cc-weight-unit]');
    const kgWrap = section.querySelector('[data-cc-weight-kg]');
    const stoneWrap = section.querySelector('[data-cc-weight-stone]');
    const sheetURL = 'https://docs.google.com/spreadsheets/d/1vgQt76bb3Rh5IHWteA4SyHB7tjNWv-3VaAkzxzuyLGU/gviz/tq?tqx=out:json';
    let searchTimer = null;

    let productPayload = { products: [] };
    try {
      productPayload = JSON.parse(dataNode.textContent);
    } catch (error) {
      productPayload = { products: [] };
    }

    const productMap = {};
    productPayload.products.forEach((product) => {
      const values = parseCaffeine(product.clarity);
      productMap[product.key] = { ...product, values };
    });

    const drinks = [
      { key: 'cc-wake-up', name: 'Counter Coffee Wake Up Espresso', serving: 'Single espresso / filter', productKey: 'wake-up', valueKey: 'filter', notes: 'Strongest, boldest Counter Coffee with the highest caffeine content.' },
      { key: 'cc-first-thing', name: 'Counter Coffee First Thing Filter', serving: 'Filter / cafetiere', productKey: 'first-thing', valueKey: 'filter', notes: 'Second strongest option and best suited to cafetiere or first filter of the day.' },
      { key: 'cc-uplift', name: 'Counter Coffee Uplift Espresso', serving: 'Espresso', productKey: 'uplift', valueKey: 'espresso', notes: 'Regular-strength espresso that works well later in the morning.' },
      { key: 'cc-refuel', name: 'Counter Coffee Refuel Filter', serving: 'Typical serving', productKey: 'refuel', valueKey: 'typical', notes: 'Regular-strength filter coffee for later in the morning.' },
      { key: 'cc-easy-afternoon', name: 'Counter Coffee Easy Afternoon Half Caf', serving: 'Typical serving', productKey: 'easy-afternoon', valueKey: 'typical', notes: 'Half caf coffee designed for afternoons.' },
      { key: 'cc-decaf', name: 'Counter Coffee All Day Decaf', serving: 'Filter / espresso', productKey: 'decaf', valueKey: 'filter', notes: 'Decaf option for anytime coffee routines.' },
      { key: 'instant', name: 'Mug of instant coffee', serving: 'Mug, around 200ml', caffeine: 100, notes: 'NHS pregnancy guidance lists 100mg for a mug of instant coffee.' },
      { key: 'filter', name: 'Mug of filter coffee', serving: 'Mug, around 200ml', caffeine: 140, notes: 'NHS lists 140mg for a mug of filter coffee; public guidance examples vary by serving.' },
      { key: 'espresso', name: 'Espresso', serving: 'Single shot', caffeine: 80, notes: 'Approximate. Public guidance examples often use around 80mg for espresso.' },
      { key: 'double-espresso', name: 'Double espresso', serving: 'Double shot', caffeine: 160, notes: 'Approximate. Brand and dose can change this significantly.' },
      { key: 'americano', name: 'Americano', serving: 'Standard cup', caffeine: 80, notes: 'Usually one or two espresso shots, so caffeine depends on the recipe.' },
      { key: 'flat-white', name: 'Flat white', serving: 'Standard cup', caffeine: 120, notes: 'Often made with a double espresso, but shop recipes vary.' },
      { key: 'latte', name: 'Latte', serving: 'Standard cup', caffeine: 80, notes: 'Usually espresso-based; caffeine depends on number of shots.' },
      { key: 'cappuccino', name: 'Cappuccino', serving: 'Standard cup', caffeine: 80, notes: 'Usually espresso-based; caffeine depends on number of shots.' },
      { key: 'tea', name: 'Tea', serving: 'Mug', caffeine: 75, notes: 'NHS lists around 75mg for a mug of tea.' },
      { key: 'green-tea', name: 'Green tea', serving: 'Mug', caffeine: 35, notes: 'Varies by brand and brew time; NHS notes green tea can sometimes be similar to regular tea.' },
      { key: 'cola', name: 'Cola', serving: 'Can', caffeine: 40, notes: 'NHS lists around 40mg for a can of cola.' },
      { key: 'energy-drink', name: 'Energy drink', serving: '250ml can', caffeine: 80, notes: 'NHS and FSA examples commonly use around 80mg for a 250ml can.' }
    ];

    renderTable();
    updateVisibility();
    calculate();

    searchNode.addEventListener('input', () => {
      filterDatabase(searchNode.value);
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(() => trackSearch(searchNode.value), 650);
    });

    section.addEventListener('input', calculate);
    section.addEventListener('change', () => {
      updateVisibility();
      calculate();
    });

    function parseCaffeine(text) {
      const source = text || '';
      const values = {};
      const regex = /([^.\n:]*?)\(?[^)\n]*?\)?:?\s*(\d+(?:\.\d+)?)\s*mg/gi;
      let match = regex.exec(source);

      while (match) {
        const context = (match[1] || '').toLowerCase();
        const value = Number(match[2]);
        if (context.includes('double espresso')) values.doubleEspresso = value;
        else if (context.includes('single espresso') || context.includes('espresso')) values.espresso = value;
        else if (context.includes('filter')) values.filter = value;
        else if (context.includes('serving') || context.includes('typical')) values.typical = value;
        else if (!values.typical) values.typical = value;
        match = regex.exec(source);
      }

      return values;
    }

    function drinkCaffeine(drink) {
      if (!drink.productKey) return drink.caffeine;
      const product = productMap[drink.productKey];
      if (!product) return null;
      return product.values[drink.valueKey] || product.values.typical || product.values.filter || product.values.espresso || null;
    }

    function updateVisibility() {
      const unit = Array.from(unitRadios).find((radio) => radio.checked)?.value || 'kg';
      kgWrap.hidden = unit !== 'kg';
      stoneWrap.hidden = unit !== 'stone';
    }

    function getWeightKg() {
      const unit = Array.from(unitRadios).find((radio) => radio.checked)?.value || 'kg';
      if (unit === 'kg') return Number(section.querySelector('[data-cc-kg]').value) || 0;
      const stone = Number(section.querySelector('[data-cc-stone]').value) || 0;
      const pounds = Number(section.querySelector('[data-cc-pounds]').value) || 0;
      return ((stone * 14) + pounds) * 0.45359237;
    }

    function getReference() {
      const sensitivity = section.querySelector('input[name="cc-sensitivity"]:checked')?.value || 'normal';
      const weightKg = getWeightKg();
      const multiplier = sensitivity === 'tolerant' ? 5.5 : sensitivity === 'sensitive' ? 2.5 : 4.5;
      return Math.max(0, Math.round(weightKg * multiplier));
    }

    function calculate() {
      const reference = getReference();
      const sensitivity = section.querySelector('input[name="cc-sensitivity"]:checked')?.value || 'normal';
      const goal = section.querySelector('input[name="cc-goal"]:checked')?.value || 'boost-focus';
      const weightKg = getWeightKg();
      const perKg = weightKg > 0 ? reference / weightKg : 0;
      const filterCoffees = reference / 140;
      const doubleEspressos = reference / 160;
      const bedtimeHour = 22;
      const finalCoffeeHour = 14;
      const sleepTarget = sleepTargetBand(sensitivity, goal);
      const candidatePlan = buildPlan(reference, sensitivity, goal, finalCoffeeHour);
      const plan = adjustFinalCoffeeForSleep(candidatePlan, sensitivity, goal, sleepTarget.target, bedtimeHour);
      const remainingAtBed = Math.round(remainingCaffeineAt(plan, bedtimeHour));
      const sleepImpact = sleepImpactLabel(remainingAtBed);
      const sleepPosition = sleepMarkerPosition(remainingAtBed);

      totalNode.textContent = reference;
      referenceCopyNode.textContent = `Approximate limit based on ${weightKg.toFixed(1)}kg and ${perKg.toFixed(1)}mg per kg for your selected sensitivity.`;
      messageNode.textContent = `That is roughly ${filterCoffees.toFixed(1)} mugs of filter coffee at 140mg each, or ${doubleEspressos.toFixed(1)} double espressos at 160mg each. FSA guidance commonly references up to 400mg per day for healthy adults.`;
      sleepTargetNode.textContent = `Assuming your final coffee is at 14:00 and bedtime is 22:00, this estimates total caffeine remaining at bedtime from the selected routine.`;
      sleepReadingNode.textContent = `Estimated caffeine remaining at 22:00: ${remainingAtBed}mg. ${sleepImpact}`;
      sleepMessageNode.textContent = sleepMessage(plan, sleepTarget, remainingAtBed);
      if (sleepGraphicNode) sleepGraphicNode.style.setProperty('--cc-sleep-position', `${sleepPosition}%`);
      planSummaryNode.textContent = `Suggested routine for ${goalLabel(goal).toLowerCase()} is planned around your estimated daily caffeine limit of ${reference}mg. Assumed times: 08:00, 11:00 and 14:00.`;
      renderPlan(plan);
    }

    function buildPlan(reference, sensitivity, goal, lastCoffeeHour) {
      const wakeEspresso = productValue('wake-up', 'espresso');
      const firstThingFilter = productValue('first-thing', 'filter');
      const firstThingEspresso = productValue('first-thing', 'espresso');
      const upliftFilter = productValue('uplift', 'filter');
      const upliftEspresso = productValue('uplift', 'espresso');
      const refuelFilter = productValue('refuel', 'filter');
      const refuelTypical = productValue('refuel', 'typical');
      const easyFilter = productValue('easy-afternoon', 'filter');
      const easyTypical = productValue('easy-afternoon', 'typical');
      const decafFilter = productValue('decaf', 'filter');

      if (goal === 'improve-sleep' || goal === 'reduce-jitters' || goal === 'reduce-anxiety') {
        return [
          planItem('Morning', 8, productMap.refuel, productValue('refuel', 'espresso') || refuelTypical || refuelFilter, servingLabel('Single Espresso', productValue('refuel', 'espresso') || refuelTypical || refuelFilter), 'Regular-strength first coffee without going straight to the strongest option.'),
          planItem('Late morning', 11, productMap['easy-afternoon'], easyFilter || easyTypical, servingLabel('Filter coffee', easyFilter || easyTypical), 'Half caf filter coffee for a gentler second cup.'),
          planItem('Third coffee', lastCoffeeHour, productMap['easy-afternoon'], easyFilter || easyTypical, servingLabel('Filter coffee', easyFilter || easyTypical), 'Half caf filter coffee for a lower-caffeine 14:00 final coffee.')
        ];
      }

      if (goal === 'survive-parenthood') {
        return [
          planItem('Morning', 8, productMap['wake-up'], wakeEspresso, servingLabel('Single Espresso', wakeEspresso), 'The strongest, boldest single espresso option for the first shift.'),
          planItem('Late morning', 11, productMap['first-thing'], firstThingFilter, servingLabel('Filter coffee', firstThingFilter), 'Second strongest filter coffee and especially good if you want a cafetiere-friendly brew.'),
          planItem('Third coffee', lastCoffeeHour, productMap['easy-afternoon'], easyFilter || easyTypical, servingLabel('Filter coffee', easyFilter || easyTypical), 'Half caf filter coffee when you still want coffee later.')
        ];
      }

      if (goal === 'endurance-sports') {
        return [
          planItem('Pre-session', 8, productMap['wake-up'], wakeEspresso, servingLabel('Single Espresso', wakeEspresso), 'The strongest measured single espresso option in this routine.'),
          planItem('Recovery', 11, productMap['first-thing'], firstThingFilter, servingLabel('Filter coffee', firstThingFilter), 'Second strongest filter choice and well suited to cafetiere.'),
          planItem('Third coffee', lastCoffeeHour, productMap['easy-afternoon'], easyFilter || easyTypical, servingLabel('Filter coffee', easyFilter || easyTypical), 'Half caf filter coffee to keep the day controlled.')
        ];
      }

      if (sensitivity === 'sensitive' || reference <= 220) {
        return [
          planItem('Morning', 8, productMap.uplift, upliftEspresso, servingLabel('Single Espresso', upliftEspresso), 'Regular-strength single espresso for a measured start.'),
          planItem('Late morning', 11, productMap['easy-afternoon'], easyFilter || easyTypical, servingLabel('Filter coffee', easyFilter || easyTypical), 'Lower caffeine filter coffee for the second cup.'),
          planItem('Third coffee', lastCoffeeHour, productMap['easy-afternoon'], easyFilter || easyTypical, servingLabel('Filter coffee', easyFilter || easyTypical), 'Half caf filter coffee for a lower-caffeine 14:00 final coffee.')
        ];
      }

      if (reference >= 360) {
        return [
          planItem('Morning', 8, productMap['wake-up'], wakeEspresso, servingLabel('Single Espresso', wakeEspresso), 'Strong single espresso while staying around the daily limit.'),
          planItem('Late morning', 11, productMap['first-thing'], firstThingFilter, servingLabel('Filter coffee', firstThingFilter), 'Second strongest filter choice for a cafetiere-friendly follow-up.'),
          planItem('Third coffee', lastCoffeeHour, productMap['easy-afternoon'], easyFilter || easyTypical, servingLabel('Filter coffee', easyFilter || easyTypical), 'Half caf filter coffee to round out the day without jumping straight to decaf.')
        ];
      }

      return [
        planItem('Morning', 8, productMap['first-thing'], firstThingEspresso || firstThingFilter, servingLabel('Single Espresso', firstThingEspresso || firstThingFilter), 'Second strongest option as a single espresso for your first coffee.'),
        planItem('Late morning', 11, productMap.uplift, upliftFilter || upliftEspresso, servingLabel('Filter coffee', upliftFilter || upliftEspresso), 'Regular-strength filter coffee for later in the morning.'),
        planItem('Third coffee', lastCoffeeHour, productMap['easy-afternoon'], easyFilter || easyTypical, servingLabel('Filter coffee', easyFilter || easyTypical), 'Half caf filter coffee for later in the day.')
      ];
    }

    function goalLabel(goal) {
      const labels = {
        'improve-sleep': 'Improve sleep',
        'reduce-jitters': 'Reduce jitters',
        'boost-focus': 'Boost focus',
        'survive-parenthood': 'Survive parenthood',
        'reduce-anxiety': 'Reduce anxiety',
        'endurance-sports': 'For endurance sports'
      };
      return labels[goal] || 'Boost focus';
    }

    function formatTime(hourValue) {
      const totalMinutes = Math.round(hourValue * 60);
      const hours = Math.floor(totalMinutes / 60) % 24;
      const minutes = totalMinutes % 60;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    }

    function remainingCaffeineAt(plan, targetHour) {
      const halfLifeHours = 5;
      return plan.reduce((sum, item) => {
        const elapsed = Math.max(0, targetHour - item.hour);
        return sum + (item.caffeine * Math.pow(0.5, elapsed / halfLifeHours));
      }, 0);
    }

    function sleepTargetBand(sensitivity, goal) {
      const sensitivityTargets = {
        sensitive: 20,
        normal: 60,
        tolerant: 100
      };
      const goalTargets = {
        'improve-sleep': 20,
        'reduce-anxiety': 20,
        'reduce-jitters': 60,
        'boost-focus': 60,
        'endurance-sports': 100,
        'survive-parenthood': 60
      };
      const target = goalTargets[goal] || sensitivityTargets[sensitivity] || 60;
      return { target };
    }

    function adjustFinalCoffeeForSleep(plan, sensitivity, goal, targetMg, bedtimeHour) {
      if (remainingCaffeineAt(plan, bedtimeHour) <= targetMg) return plan;
      const easyFilter = productValue('easy-afternoon', 'filter');
      if (!easyFilter || plan[2]?.product?.key === 'easy-afternoon') return plan;
      const halfCafPlan = [
        plan[0],
        plan[1],
        planItem('Final coffee', 14, productMap['easy-afternoon'], easyFilter, servingLabel('Filter coffee', easyFilter), 'Easy Afternoon Half Caf keeps the final coffee lower in caffeine while still giving you a proper coffee at 14:00.')
      ];
      return halfCafPlan;
    }

    function sleepMessage(plan, sleepTarget, remainingAtBed) {
      const finalProduct = plan[2]?.product?.title || 'your final coffee';
      const finalProductKey = plan[2]?.product?.key || '';
      const secondProduct = plan[1]?.product?.title || 'your second coffee';
      const targetText = sleepTarget.target === 20 ? 'under 20mg' : sleepTarget.target === 60 ? '20-60mg' : '60-100mg';
      const status = remainingAtBed <= sleepTarget.target ? 'within' : 'above';
      let suggestion = 'This fits the selected bedtime range.';
      if (remainingAtBed > sleepTarget.target) {
        suggestion = finalProductKey === 'easy-afternoon'
          ? `If you want to bring this down, consider a two-coffee day and drop ${secondProduct}, or keep Easy Afternoon Half Caf earlier and skip the final coffee.`
          : 'If you want to bring this down, choose Easy Afternoon Half Caf for the final coffee, move the final coffee earlier or reduce the number of caffeinated coffees.';
      }
      return `With ${finalProduct} at 14:00, this is ${status} your selected bedtime target range of ${targetText}. ${suggestion}`;
    }

    function sleepImpactLabel(remainingMg) {
      if (remainingMg < 20) return 'Under 20mg is unlikely to noticeably affect most people.';
      if (remainingMg <= 60) return '20-60mg is probably fine for many, but sensitive individuals may notice an effect.';
      if (remainingMg <= 100) return '60-100mg has an increasing likelihood of reduced sleep quality or delayed sleep onset.';
      return '100mg+ is likely to affect sleep in a significant proportion of people.';
    }

    function sleepMarkerPosition(remainingMg) {
      const chartMaxMg = 120;
      return Math.max(0, Math.min(100, (remainingMg / chartMaxMg) * 100));
    }

    function productValue(productKey, valueKey) {
      const product = productMap[productKey];
      if (!product) return null;
      return product.values[valueKey] || product.values.typical || product.values.filter || product.values.espresso || null;
    }

    function servingLabel(serving, caffeine) {
      if (!caffeine) return 'Caffeine value unavailable';
      return `${serving} - ${caffeine} mg`;
    }

    function planItem(time, hour, product, caffeine, caffeineText, reason) {
      return { time, hour, product, caffeine: caffeine || 0, caffeineText, reason };
    }

    function renderPlan(plan) {
      planNode.innerHTML = plan.map((item) => {
        const product = item.product || {};
        const caffeineText = item.caffeineText || (item.caffeine ? `Measured caffeine - ${item.caffeine} mg` : 'Caffeine value unavailable');
        return `
          <div class="cc-caffeine-product">
            ${product.image ? `<img src="${product.image}" alt="">` : ''}
            <div>
              <span class="cc-caffeine-time">${formatTime(item.hour)} ${item.time}</span>
              <h3>${product.title || 'Counter Coffee'}</h3>
              <p><strong>${caffeineText}</strong></p>
              <p>${item.reason}</p>
              <a href="${product.url || '/collections/all'}">View coffee</a>
            </div>
          </div>
        `;
      }).join('');
    }

    function renderTable() {
      tableNode.innerHTML = drinks.map((drink) => {
        const caffeine = drinkCaffeine(drink);
        const caffeineText = caffeine === null ? 'Caffeine value unavailable' : `${caffeine}mg`;
        const matchedProduct = matchedCounterCoffeeProduct(drink, caffeine);
        const searchable = `${drink.name} ${drink.serving} ${caffeineText} ${drink.notes} ${matchedProduct?.title || ''}`.toLowerCase();
        const product = drink.productKey ? productMap[drink.productKey] : null;
        return `
          <tr data-cc-search-row data-cc-search-text="${escapeAttribute(searchable)}">
            <td>${product ? `<a href="${product.url}">${drink.name}</a>` : drink.name}</td>
            <td>${drink.serving}</td>
            <td>${caffeineText}</td>
            <td>${drink.notes}</td>
            <td>${renderAlternativeProduct(matchedProduct, Boolean(product))}</td>
          </tr>
        `;
      }).join('');
      filterDatabase('');
      fetchExternalDatabase();
    }

    async function fetchExternalDatabase() {
      try {
        const response = await fetch(sheetURL);
        const text = await response.text();
        const json = JSON.parse(text.substr(47).slice(0, -2));
        const rows = json.table.rows.slice(1);
        rows.forEach((row) => {
          const cells = row.c || [];
          const category = cells[0]?.v || '';
          const brand = cells[1]?.v || '';
          const perBase = cells[2]?.v || '';
          const unit = cells[3]?.v || '';
          const serving = cells[4]?.v || '';
          const perServing = cells[5]?.v || '';
          const notes = cells[6]?.v || '';
          const caffeine = parseCaffeineAmount(perServing || perBase);
          const matchedProduct = closestCounterCoffeeProduct(caffeine, `${category} ${brand} ${serving} ${notes}`);
          const searchable = `${category} ${brand} ${perBase} ${unit} ${serving} ${perServing} ${notes} ${matchedProduct?.title || 'Counter Coffee'}`.toLowerCase();
          const tr = document.createElement('tr');
          tr.setAttribute('data-cc-search-row', '');
          tr.setAttribute('data-cc-search-text', searchable);
          tr.innerHTML = `
            <td>${escapeHtml(brand || category)}</td>
            <td>${escapeHtml(serving)}</td>
            <td>${escapeHtml(perServing)}</td>
            <td>${escapeHtml([category, perBase, unit, notes].filter(Boolean).join(' | '))}</td>
            <td>${renderAlternativeProduct(matchedProduct, false)}</td>
          `;
          tableNode.appendChild(tr);
        });
        filterDatabase(searchNode.value);
      } catch (error) {
        const tr = document.createElement('tr');
        tr.setAttribute('data-cc-search-row', '');
        tr.setAttribute('data-cc-search-text', 'database unavailable');
        tr.innerHTML = '<td>Full database unavailable</td><td></td><td></td><td>The extended database could not be loaded.</td><td><a href="/collections/our-range">Shop Counter Coffee</a></td>';
        tableNode.appendChild(tr);
        filterDatabase(searchNode.value);
      }
    }

    function matchedCounterCoffeeProduct(drink, caffeine) {
      if (drink.productKey && productMap[drink.productKey]) return productMap[drink.productKey];
      return closestCounterCoffeeProduct(caffeine, `${drink.name} ${drink.serving} ${drink.notes}`);
    }

    function closestCounterCoffeeProduct(caffeine, context = '') {
      const amount = Number(caffeine);
      if (!Number.isFinite(amount)) return productMap['easy-afternoon'] || productMap.refuel || productMap.decaf || null;
      const servingPreference = preferredServingType(context);
      const matches = [];

      Object.values(productMap).forEach((product) => {
        Object.entries(product.values || {}).forEach(([servingType, value]) => {
          if (!Number.isFinite(Number(value))) return;
          const servingPenalty = servingPreference && servingType !== servingPreference ? 12 : 0;
          matches.push({
            product,
            score: Math.abs(Number(value) - amount) + servingPenalty
          });
        });
      });

      matches.sort((a, b) => a.score - b.score);
      return matches[0]?.product || productMap['easy-afternoon'] || productMap.refuel || productMap.decaf || null;
    }

    function preferredServingType(context) {
      const text = String(context).toLowerCase();
      if (text.includes('espresso') || text.includes('americano') || text.includes('latte') || text.includes('flat white') || text.includes('cappuccino')) return 'espresso';
      if (text.includes('filter') || text.includes('cafetiere') || text.includes('mug')) return 'filter';
      return '';
    }

    function parseCaffeineAmount(value) {
      const match = String(value || '').match(/(\d+(?:\.\d+)?)/);
      return match ? Number(match[1]) : null;
    }

    function renderAlternativeProduct(product, imageOnly = false) {
      if (!product) return '<a href="/collections/our-range">Shop Counter Coffee</a>';
      const image = product.image ? `<img src="${escapeAttribute(product.image)}" alt="">` : '';
      const label = imageOnly ? `<span class="visually-hidden">${escapeHtml(product.title)}</span>` : `<span>${escapeHtml(product.title)}</span>`;
      const modifier = imageOnly ? ' cc-caffeine-table__product-link--image-only' : '';
      return `<a class="cc-caffeine-table__product-link${modifier}" href="${escapeAttribute(product.url)}" aria-label="${escapeAttribute(product.title)}">${image}${label}</a>`;
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function filterDatabase(query) {
      const value = query.trim().toLowerCase();
      let count = 0;
      tableNode.querySelectorAll('[data-cc-search-row]').forEach((row) => {
        const match = !value || row.dataset.ccSearchText.includes(value);
        row.hidden = !match;
        if (match) count += 1;
      });
      searchCountNode.textContent = count;
    }

    function trackSearch(query) {
      const value = query.trim();
      if (!value) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'caffeine_database_search',
        search_term: value,
        result_count: Number(searchCountNode.textContent) || 0
      });
      section.dispatchEvent(new CustomEvent('cc:caffeineDatabaseSearch', {
        bubbles: true,
        detail: {
          searchTerm: value,
          resultCount: Number(searchCountNode.textContent) || 0
        }
      }));
    }

    function escapeAttribute(value) {
      return String(value).replace(/"/g, '&quot;');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
